(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.sessions')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.sessions', {
        url: '/sessions',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/sessions/sessions.tpl.html',
            controller: 'EntitatsMainSessionsCtrl',
            controllerAs: 'ctrl',
            resolve: {
              usuarissessioData: function(EntitatFactory, $stateParams){
                return EntitatFactory.getsessions($stateParams.idEntitat);
              }
            }
          }
        },
        breadcrumb: 'USUARIS_SESSIO'
      });
  }
}());
